import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

/**
 * Anokina Studio branded toast.
 *
 * Design notes:
 *   • Compact, calm, cream/warm background — no bright green.
 *   • Brown typography (espresso), gold accent for success icon.
 *   • Never richColors (that's what turns success bright green).
 *   • Applied globally, per-screen overrides not needed.
 */
const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      // richColors=false — we ship our own palette below.
      toastOptions={{
        style: {
          background: "#F5EFE1",         // cream
          color: "#3B241A",              // brown typography
          border: "1px solid rgba(59,36,26,0.14)",
          borderRadius: 12,
          padding: "10px 14px",
          fontFamily: "'Jost', system-ui, sans-serif",
          fontSize: 14,
          boxShadow: "0 8px 22px -12px rgba(59,36,26,0.35), 0 2px 6px -2px rgba(59,36,26,0.15)",
        },
        classNames: {
          toast: "group toast",
          description: "text-[13px] opacity-80",
          actionButton:
            "!bg-[#2a1810] !text-[#efe4d0] !rounded-full !px-3 !py-1.5 !text-[12px] !uppercase !tracking-widest",
          cancelButton:
            "!bg-transparent !text-[#3b241a]/70 !text-[12px]",
          // Semantic overrides — keep the same warm palette, only change the icon accent.
          success:
            "!bg-[#F5EFE1] !text-[#3B241A] !border-[#C9A84C]/40 [&_[data-icon]]:!text-[#8a6a1e]",
          error:
            "!bg-[#F7EAE3] !text-[#5a1a14] !border-[#a03a2b]/30 [&_[data-icon]]:!text-[#a03a2b]",
          warning:
            "!bg-[#F5EAD8] !text-[#3B241A] !border-[#C9A84C]/40 [&_[data-icon]]:!text-[#8a6a1e]",
          info:
            "!bg-[#F5EFE1] !text-[#3B241A] !border-[#3B241A]/20",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
